export default __webpack_public_path__ + "static/media/PregnantWalletBar.56c984a2.svg";